// tienda/ProcesoSection.jsx
// 3-step "how it works" section.

import React from "react";
import { motion } from "framer-motion";
import { FileSpreadsheet, Truck, CheckCircle2 } from "lucide-react";
import { brand, fadeUp } from "../shared/brand";

const STEPS = [
  {
    step:  "1",
    title: "Sube tus pedidos",
    icon:  <FileSpreadsheet className="size-6" />,
    text:  "Arrastra y suelta un Excel con tus entregas en la plataforma.",
    badge: "Carga masiva",
  },
  {
    step:  "2",
    title: "Recojo inmediato",
    icon:  <Truck className="size-6" />,
    text:  "Pasamos por tu tienda o almacén para recoger los paquetes.",
    badge: "Operación ágil",
  },
  {
    step:  "3",
    title: "Entrega el mismo día",
    icon:  <CheckCircle2 className="size-6" />,
    text:  "Tus clientes reciben antes de las 8:00 PM. COD si aplica.",
    badge: "Cumplimiento",
  },
];

export function ProcesoSection() {
  return (
    <section id="proceso" className="border-b border-slate-100 bg-white scroll-mt-16">
      <div className="mx-auto max-w-7xl px-4 py-12 md:py-16">
        <motion.h2 {...fadeUp} className="text-2xl font-extrabold mb-8" style={{ color: brand.primary }}>
          ¿Cómo funciona?
        </motion.h2>
        <div className="grid gap-4 md:grid-cols-3">
          {STEPS.map(p => (
            <motion.div
              key={p.step}
              {...fadeUp}
              className="relative rounded-2xl border border-slate-100 bg-slate-50 p-5"
            >
              <div
                className="absolute -top-3 left-5 rounded-full px-2.5 py-0.5 text-xs font-bold text-white"
                style={{ background: brand.primary }}
              >
                Paso {p.step}
              </div>
              <div className="flex items-start gap-4 mt-2">
                <div className="grid size-11 place-items-center rounded-xl bg-white border border-slate-100 text-slate-600 shrink-0">
                  {p.icon}
                </div>
                <div>
                  <h3 className="text-sm font-bold text-slate-800">{p.title}</h3>
                  <p className="mt-1 text-xs text-slate-500">{p.text}</p>
                  <span className="mt-2 inline-flex rounded-lg bg-white border border-slate-200 px-2 py-0.5 text-[11px] font-medium text-slate-600">
                    {p.badge}
                  </span>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}